import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Box, IconButton, Typography, Paper } from '@mui/material';
import FeatherIcon from 'feather-icons-react';

const CategoryTable = ({ items, onEdit, onDelete }) => {
  const columns = [
    { dataField: 'name', text: 'Name', sort: true },
    {
      dataField: 'createdAt',
      text: 'Created At',
      sort: true,
      formatter: (cell) =>
        cell ? new Date(cell).toLocaleDateString() : 'N/A',
    },
    {
      dataField: 'updatedAt',
      text: 'Updated At',
      sort: true,
      formatter: (cell) =>
        cell ? new Date(cell).toLocaleDateString() : 'N/A',
    },
    {
      dataField: 'actions',
      text: 'Actions',
      formatter: (cell, row) => (
        <Box>
          <IconButton onClick={() => onEdit(row)} title="Edit" size="small">
            <FeatherIcon icon="edit" size={18} />
          </IconButton>
          <IconButton onClick={() => onDelete(row)} title="Delete" size="small">
            <FeatherIcon icon="trash-2" size={18} color="red" />
          </IconButton>
        </Box>
      ),
    },
  ];

  const paginationOptions = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const NoDataIndication = () => (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="45vh"
      width="100%"
    >
      <Box textAlign="center" py={4}>
        <FeatherIcon icon="inbox" size={40} style={{ opacity: 0.5, marginBottom: '16px' }} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          There are no inventory categories to display
        </Typography>
      </Box>
    </Box>
  );

  const tableStyles = {
    minHeight: '50vh',
    maxHeight: '70vh',
    overflow: 'auto',
    borderRadius: 1,
    boxShadow: 1,
    position: 'relative',
    zIndex: 1,
    '& .react-bootstrap-table': {
      minHeight: '45vh'
    },
    '& table': {
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    '& thead th': {
      position: 'sticky',
      top: 0,
      backgroundColor: '#f8f9fa',
      zIndex: 2,
      borderBottom: '2px solid #dee2e6',
      padding: '12px 8px',
    },
    '& tbody tr:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
    },
    '& .pagination': {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '16px',
      borderTop: '1px solid #dee2e6',
    }
  };

  return (
    <Paper sx={tableStyles} className="miui-table scrollable-table">
      <BootstrapTable
        keyField="_id"
        data={items || []}
        columns={columns}
        pagination={paginationFactory(paginationOptions)}
        bootstrap4
        bordered={false}
        hover
        responsive
        noDataIndication={NoDataIndication}
        wrapperClasses="table-responsive"
      />
    </Paper>
  );
};

export { CategoryTable };
